var Student = "학생";
var jobRole = {
	"Job role": "직무",
	"Academic / Researcher": "학술 관련 종사자 또는 연구원",
	"Advisor / Consultant": "어드바이저/컨설턴트",
	"Business Executive": "비즈니스 임원",
	"Developer / Engineer": "개발자/엔지니어",
	"Entrepreneur (Founder/Co-Founder)": "기업가(창업주/공동 창업주)",
	"IT Executive": "IT 임원",
	"IT Professional or Technical Manager": "IT 전문가 또는 기술 관리자",
	"Press / Media Analyst": "언론/미디어 분석가",
	"Sales / Marketing": "영업/마케팅",
	Student: Student,
	"Solution or Systems Architect": "솔루션 또는 시스템 아키텍트",
	"System Administrator": "시스템 관리자",
	"Venture Capitalist": "벤처 투자가"
};

export { Student, jobRole as default };
